// extracted by css-extract-rspack-plugin
export default {"form":"_2_-IgE7oP12L1XLSrgcv9h"};